<ion-content class="account-settings-screen tw-pt-[16px] tw-pb-[16px] tw-pr-[30px] tw-pl-[30px]" data-cy="account-settings-screen">

  <!-- Heading -->
  <div class="heading-section tw-relative">
    <ion-icon
      data-cy="account-settings-back"
      name="arrow-back-outline"
      (click)="close()"
      class="soft-back tw-text-[20px] tw-text-white tw-p-[5px] tw-absolute"
    />
    <ion-title class="tw-text-center"
      class="
      tw-text-center
      tw-text-[20px]
      tw-font-bold
      "
      data-cy="acc-settings-title"
    >
      Account Settings
    </ion-title>
    <span (click)="close()"
      class="
      close
      tw-absolute
      tw-capitalize
      tw-text-[16px]
    "
    data-cy="account-settings-close">
      Close
    </span>
  </div>

  <!-- Settings -->
  <div class="my-settings-section">

    <!-- Wagering Preferences -->
    <div
      (click)="selectCard('wageringPreferences')"
      class="wageringPreferences settings-row"
      data-name="wageringPreferences"
      data-cy="wagering-preferences"
    >
      <img
        src="/assets/images/account_settings/wagering_preferences_icon_light.svg"
        class="l-mode tw-w-[28px] tw-inline tw-mr-[22px]"
      >
      <img
        src="/assets/images/account_settings/wagering_preferences_icon_dark.svg"
        class="d-mode tw-w-[28px] tw-inline tw-mr-[22px]"
      >
      <span slot="start" class="tw-text-[16px]">Wagering Preferences</span>
      <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right"></ion-icon>
      <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
    </div>

    <!-- Language -->
    <div (click)="openLanguage()" class="settings-row" data-cy="settings-language">
      <img
        src="/assets/images/account_settings/language_icon_light.svg"
        class="l-mode tw-inline tw-mr-[19px]"
      >
      <img
        src="/assets/images/account_settings/language_icon_dark.svg"
        class="d-mode tw-inline tw-mr-[19px]"
      >
      <span slot="start" class="tw-text-[16px]">Language</span>
      <ion-icon name="chevron-forward-outline" class="chev-right"></ion-icon>
    </div>

    <!-- Wagering Limits -->
    <div
      (click)="selectCard('wageringLimits')"
      class="wageringLimits settings-row"
      data-name="wageringLimits"
      data-cy="wagering-limits"
    >
      <img
        src="/assets/images/account_settings/wagering_limits_icon_light.png"
        class="l-mode tw-w-[28px] tw-inline tw-mr-[22px]"
      >
      <img
        src="/assets/images/account_settings/wagering_limits_icon_dark.png"
        class="d-mode tw-w-[28px] tw-inline tw-mr-[22px]"
      >
      <span slot="start" class="tw-text-[16px]">Wagering Limits</span>
      <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right"></ion-icon>
      <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
    </div>

    <!-- Change Password -->
    <div
      (click)="selectCard('changePassword')"
      class="changePassword settings-row"
      data-name="changePassword"
      data-cy="settings-change-pw"
    >
      <img
        src="/assets/images/account_settings/change_password_icon_light.svg"
        class="l-mode tw-inline tw-mr-[25px]"
      >
      <img
        src="/assets/images/account_settings/change_password_icon_dark.svg"
        class="d-mode tw-inline tw-mr-[25px]"
      >
      <span slot="start" class="tw-text-[16px]">Change Password</span>
      <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right"></ion-icon>
      <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
    </div>

    <!-- Favorite Tracks -->
    <div
      (click)="selectCard('favoriteTracks')"
      class="favoriteTracks settings-row"
      data-name="favoriteTracks"
      data-cy="favorite-tracks"
    >
      <img
        src="/assets/images/account_settings/favorite_tracks_icon_light.svg"
        class="l-mode tw-w-[28px] tw-inline tw-mr-[22px]"
      >
      <img
        src="/assets/images/account_settings/favorite_tracks_icon_dark.svg"
        class="d-mode tw-w-[28px] tw-inline tw-mr-[22px]"
      >
      <span slot="start" class="tw-text-[16px]">Favorite Tracks</span>
      <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right"></ion-icon>
      <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
    </div>

    <!-- Dynamic Content -->
    <div class="content">
      <!-- Wagering Preferences -->
      <div class="wageringPreferences card-content card-hide" data-name="wageringPreferences">
        <feature-ion-wagering-preferences *ngIf="controller.wageringPreferences">
        </feature-ion-wagering-preferences>
      </div>

      <!-- Wagering Limits -->
      <div class="wageringLimits card-content card-hide" data-name="wageringLimits">
        <feature-ion-wagering-limits *ngIf="controller.wageringLimits">
        </feature-ion-wagering-limits>
      </div>

      <!-- Change Password -->
      <div class="changePassword card-content card-hide" data-name="changePassword">
        <ion-button (click)="changePasswordPrompt()" data-cy="change-pw-btn">Change Login Password</ion-button>
      </div>

      <!-- Favorite Tracks -->
      <div class="favoriteTracks card-content card-hide" data-name="favoriteTracks">
        <feature-ion-favorite-tracks *ngIf="controller.favoriteTracks">
        </feature-ion-favorite-tracks>
      </div>

    </div>
  </div>

</ion-content>
